module.exports = __webpack_public_path__ + "img/pen.bd238789.svg";